
import FileSaver from 'file-saver';
import {
  getDownloadSParameterListAPI,
  downloadSParameterAPI,
  deleteSParameterAPI,
  transformSParameterAPI
} from '../api/download/sParameter';
import apiProcess from '../api/utility';

export function getDownLoadSParameterList({ channelId, interfaceId, product, projectId, type }) {
  return apiProcess(getDownloadSParameterListAPI, { channelId, interfaceId, product, projectId, type })
}

export function downloadSParameter(snpUrl, fileName = 'downloaded_file') {
  return new Promise((resolve, reject) => {
    downloadSParameterAPI(snpUrl).then(res => {
      const blob = new Blob([res.data], { type: 'application/zip' });
      FileSaver.saveAs(blob, `${fileName}.zip`);
      resolve();
    }).catch(error => {
      console.error('download SParameter file error:', error);
      reject(error);
    });
  })
}

export function deleteSParameter(snpUrl) {
  return apiProcess(deleteSParameterAPI, { snpUrl })
}

export function transformSParameter({ portMappings, snpUrl, targetFile, format }) {
  return apiProcess(transformSParameterAPI, { portMappings, snpUrl, targetFile, format }, false, true)
}
